var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEyeOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_142",
    "data-name": "Group 142",
    transform: "translate(-485 -1044)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "visibility-24px",
    transform: "translate(485 1044)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M0,0H29V29H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M14.292,4.5A14.291,14.291,0,0,0,1,13.563a14.278,14.278,0,0,0,26.583,0A14.291,14.291,0,0,0,14.292,4.5Zm0,15.1a6.042,6.042,0,1,1,6.042-6.042A6.044,6.044,0,0,1,14.292,19.6Zm0-9.667a3.625,3.625,0,1,0,3.625,3.625A3.62,3.62,0,0,0,14.292,9.938Z",
    transform: "translate(0.208 0.938)",
    fill: "#ff6f00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEyeOrange);
export default __webpack_public_path__ + "static/media/icon_eye_orange.0a6bb5acf22c14b9276f1627e7061312.svg";
export { ForwardRef as ReactComponent };